// extracted by mini-css-extract-plugin
export default {"popoverContainer":"pop-over_popoverContainer__Cqflr","content":"pop-over_content__dl0Ts","arrow":"pop-over_arrow__nl35c","icon":"pop-over_icon__Rxmzt"};